import React from 'react'

import { Element } from './index.styled'

const Button = ({ children, ...props }) => {
  return <Element {...props}>{children}</Element>
}

export default Button
